import EventDetail from './event-detail';

export default EventDetail;
